/**
 * @fileoverview POST handler for the "/apps/user_info/cancel_user_deletion" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoCancelUserDeletionCacheKeys } from "./constants";
import type { PostAppsUserInfoCancelUserDeletionProps, AppsUserInfoCancelUserDeletionResult } from "./types";

export const postAppsUserInfoCancelUserDeletion = reactQueryMutationAdapter(
  appsUserInfoCancelUserDeletionCacheKeys,
  (props: PostAppsUserInfoCancelUserDeletionProps): Promise<AppsUserInfoCancelUserDeletionResult> => {
    return fetch("/apps/user_info/cancel_user_deletion", "POST", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
